import { render, staticRenderFns } from "./call-center.vue?vue&type=template&id=9252d6b2&scoped=true&"
import script from "./call-center.vue?vue&type=script&lang=js&"
export * from "./call-center.vue?vue&type=script&lang=js&"
import style0 from "./call-center.vue?vue&type=style&index=0&id=9252d6b2&lang=scss&scoped=true&"
import style1 from "./call-center.vue?vue&type=style&index=1&id=9252d6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9252d6b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9252d6b2')) {
      api.createRecord('9252d6b2', component.options)
    } else {
      api.reload('9252d6b2', component.options)
    }
    module.hot.accept("./call-center.vue?vue&type=template&id=9252d6b2&scoped=true&", function () {
      api.rerender('9252d6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/call-center.vue"
export default component.exports